import { render, staticRenderFns } from "./schedule.vue?vue&type=template&id=084e47a3&"
import script from "./schedule.vue?vue&type=script&lang=ts&"
export * from "./schedule.vue?vue&type=script&lang=ts&"
import style0 from "./schedule.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports